import { Button, Menu } from 'antd';
import styled from 'styled-components';

export const Menus = styled(Menu)`
  .btn {
    color: rgba(0, 0, 0, 0.85);
    padding: 0 1rem;
  }
`;

export const Container = styled(Button)`
  margin-top: 0px;
  @media (max-width: 991.98px) {
    span + span {
      display: none;
    }
  }
`;
